// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-top-right {
  position: fixed;
  width: 25%;
  right: 15px;
  z-index: 100000;
  top: 70px;
  font-size: 14px !important;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: fadeInRight;
}
.alert-top-right .notification {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 10px;
}
.alert-top-right .notification i.fa {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.alert-success {
  padding: 10px 40px 10px 20px !important;
  text-align: center;
  background: #8ff2ae;
  color: rgb(0, 23, 63);
}

.alert-info {
  background: #f5c542;
  color: rgb(0, 23, 63);
}

@media screen and (max-width: 769px) {
  .alert-top-right {
    width: 50%;
  }
}
@media screen and (max-width: 420px) {
  .alert-top-right {
    width: 70%;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/notification-alert/alert.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,0BAAA;EAEA,wBAAA;EAEA,yBAAA;EACA,2BAAA;AACF;AAAE;EACE,yCAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAGN;;AAEA;EAEE,uCAAA;EACA,kBAAA;EAEA,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;AACF;AAIA;EACE;IACE,UAAA;EAFF;AACF;AAKA;EACE;IACE,UAAA;IAEA,mCAAA;EAHF;EAKA;IACE,UAAA;IAEA,eAAA;EAHF;AACF;AAMA;EACE;IACE,UAAA;IAEA,kCAAA;EAJF;EAMA;IACE,UAAA;IAEA,eAAA;EAJF;AACF;AAOA;EACE;IACE,UAAA;IAEA,mCAAA;EALF;EAOA;IACE,UAAA;IAEA,eAAA;EALF;AACF","sourcesContent":[".alert-top-right {\n  position: fixed;\n  width: 25%;\n  right: 15px;\n  z-index: 100000;\n  top:70px;\n  font-size: 14px !important;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  animation-name: fadeInRight;\n  .notification {\n    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .25);\n    margin-bottom: 10px;\n    i.fa {\n      position: absolute;\n      right: 10px;      \n      top: 10px;\n      cursor: pointer;\n    }\n  }\n}\n\n.alert-success {\n  // background: #2B2B2B;\n  padding: 10px 40px 10px 20px !important;\n  text-align: center;\n  // color: #fff;\n  background:#8ff2ae;\n  color: rgb(0, 23, 63);\n}\n\n.alert-info{\n  background:#f5c542;\n  color: rgb(0, 23, 63);\n}\n\n@media screen and (max-width: 769px){\n  .alert-top-right {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 420px){\n  .alert-top-right {\n    width: 70%;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
